import ReactDOM from 'react-dom';
import App from 'App';
import 'tailwindcss/tailwind.css';
import 'App.scss';

ReactDOM.render(<App />, document.getElementById('root'));
